<!--
  @修改人: xiehan
  @修改时间：2018-12-24
  @修改描述：优化dashboard
  @版本: v2.0.0
  ------------
  @description dashBoard 新增
  @author huangzhijie
  @date 2018/11/19
-->
<style>

</style>

<template>
  <div class="dashboardHandler__content">
    <back :history="history"></back>
    <div>
      <el-form
        ref="dashboardform"
        :model="formModel"
        :rules="formRules"
        :inline="true" 
        input-width="auto">
        <el-form-item :label="$t('dashBoard.name')" key="name" prop="name">
          <el-input v-model="formModel.name" :placeholder="$t('dashBoard.title')"></el-input>          
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_showList">{{ showList ? $t('dashBoard.hideList') : $t('dashBoard.showList') }}</el-button>
          <el-button type="primary" @click="e_save" v-g-rac="gRac('handlerDashBoard@save')">{{ $t('common.save') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-collapse-transition>
      <view-list v-show="showList"
        ref="viewList"  
        :control="tableControl">
      </view-list>
    </el-collapse-transition>
    <chart-list :chart-data-list="chartDataList" @chart-dashboard-click="deleteChart"></chart-list>
  </div>
</template>
<script>
import rac from '@/plugins/rac-mixin'
import back from '@/components/back'
import ViewBiz from '@/logic/intelligentMonitor/viewBiz'
import dashBoardBiz from '@/logic/intelligentMonitor/dashBoardBiz'
import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
import FilterData from '@/logic/intelligentMonitor/viewDataHelper'
import viewList from '@/views/component/view/viewList'
import chartList from '@/components/chart/chart-dashboard-list'
import validateConfig from '@/utils/validate'
import { extend } from '@/utils/tool'
const filterData = new FilterData()

let seriesColor = [
  '#0B8DE5',
  '#43CD80',
  '#40E0D0',
  '#FFEC8B',
  '#FFA07A',
  '#FF69B4',
  '#FF0000',
  '#CDC9C9',
  '#DEB887',
  '#AB82FF',
  '#B8860B',
  '#87CEEB',
  '#8FBC8F',
  '#B4EEB4',
  '#CD5B45',
  '#F08080'
]

export default {
  mixins: [rac],
  components: {
    back,
    chartList,
    viewList
  },
  data () {
    const that = this
    return {
      history: [],
      tableControl: [{
        label: that.$t('dashBoard.push'),
        callback: that.addChart
      }],
      formModel: {
        name: ''
      },
      formRules: {
        name: [{ ...validateConfig.common.notEmpty }]
      },
      showList: true,
      chartDataList: []
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'handlerDashBoard' && from.name === 'dashBoard') {
        this.resetData()
        this.init()
      }
    }
  },
  methods: {
    init () {
      if (this.$route.query.id) {
        this.getDashById()
        this.showList = false
      } else {
        this.setHistory()
      }
    },
    setHistory (name) {
      this.history = []
      this.history.push({ name: name || this.$t('dashBoard.dashBoardAdd') })
    },
    resetData () {
      this.formModel.name = ''
      this.chartDataList = []
      this.showList = true
      seriesColor = [
        '#0B8DE5',
        '#43CD80',
        '#40E0D0',
        '#FFEC8B',
        '#FFA07A',
        '#FF69B4',
        '#FF0000',
        '#CDC9C9',
        '#DEB887',
        '#AB82FF',
        '#B8860B',
        '#87CEEB',
        '#8FBC8F',
        '#B4EEB4',
        '#CD5B45',
        '#F08080'
      ]
      this.$nextTick(() => {
        this.$refs.dashboardform.clearValidate()
      })
    },
    getDashById () {
      dashBoardBiz.findBoardById({ id: this.$route.query.id }).then(data => {
        this.setHistory(data.name)
        this.formModel.name = data.name
        let promiseList = []
        data.viewList.map((item, index) => {
          if (!item.extend.style) {
            item.extend.style = {}
            for (let i in data.style[item.id]) {
              item.extend.style[i] = String(data.style[item.id][i]).indexOf('px') > -1
                ? Number(data.style[item.id][i].split('px')[0]) : Number(data.style[item.id][i])
            }
          }
          if (item.extend.group === 'others') {
            promiseList.push(this.getOthersData(item, true))
          } else {
            promiseList.push(this.getDefaultData(item, true))
          }
        })
        Promise.all(promiseList).then((res) => {
          res.map(item => {
            this.chartDataList.push(item)
          })
        })
      })
    },
    addChart (row, index, data) {
      if (this.chartDataList.filter(item => item.chartId === row.id).length > 0) {
        this.$message({
          message: this.$t('dashBoard.viewRepeatTips'),
          type: 'warning'
        })
        return
      }
      let rowInfo = extend(true, {}, row)
      if (row.extend.group === 'others') {
        this.getOthersData(rowInfo)
      } else {
        this.getDefaultData(rowInfo)
      }
    },
    deleteChart (deleteInfo) {
      this.chartDataList.splice(deleteInfo.index, 1)
    },
    getOthersData (chartInfo, fromEdit = false) {
      return new Promise((resolve, reject) => {
        ViewBiz.getSourceData({
          id: chartInfo.dataSources.id
        }).then((data) => {
          if (data.resultCode && data.resultCode !== '00000000') {
            this.$message({
              message: `${this.$t('view.dataSourceError')}: ${data.resultDesc}`,
              type: 'error'
            })
          } else {
            let dataList = this.handlerOthersData(chartInfo, data)
            if (fromEdit) {
              resolve(this.translateChartFormat(chartInfo, dataList))
            } else {
              resolve(this.chartDataList.push(this.translateChartFormat(chartInfo, dataList)))
            }
          }
        })
      })
    },
    handlerOthersData (chartInfo, data) {
      filterData.filterDataByName(data, chartInfo.param.x.field)
      let timeList = filterData.getFilterDataList()
      let dataList = []
      let yObj = {}
      chartInfo.param.y.map((item, index) => {
        filterData.filterDataByName(data, item.field)
        yObj[this.splitField(item.field)] = filterData.getFilterDataList()
      })
      timeList.map((item, index) => {
        let pushObj = {}
        pushObj[this.splitField(chartInfo.param.x.field)] = item
        for (let i in yObj) {
          pushObj[i] = yObj[i][index]
        }
        dataList.push(pushObj)
      })
      return dataList
    },
    getDefaultData (chartInfo, fromEdit = false) {
      return new Promise((resolve, reject) => {
        let requestData = {
          appName: chartInfo.extend.appName,
          group: chartInfo.extend.group,
          kpiKey: chartInfo.extend.kpiKey,
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: new Date().getTime(),
          siteCode: chartInfo.extend.siteCode
        }
        if (chartInfo.extend.isSeries) requestData.groupField = this.splitField(chartInfo.param.series)
        ITDeviceMonitorBiz.getAllChartData(requestData).then(data => {
          let seriesDataList = this.handlerDefaultData(chartInfo, data)
          if (fromEdit) {
            resolve(this.translateChartFormat(chartInfo, seriesDataList))
          } else {
            resolve(this.chartDataList.push(this.translateChartFormat(chartInfo, seriesDataList)))
          }
        })
      })
    },
    handlerDefaultData (chartInfo, data) {
      let seriesDataList = data.data
      if (chartInfo.extend.isSeries) {
        seriesDataList = []
        if (data.data && data.data.length > 0) {
          data.data[0].value.map((item, index) => {
            let pushObj = {}
            pushObj[this.splitField(chartInfo.param.x.field)] = data.data[0][this.splitField(chartInfo.param.x.field)][index]
            seriesDataList.push(pushObj)
          })
          // 转换默认数据源结构
          data.data.map((dataItem, dataIndex) => {
            dataItem[this.splitField(chartInfo.param.y[0].field)].map((yItem, yIndex) => {
              if (seriesDataList[yIndex]) seriesDataList[yIndex][dataItem[this.splitField(chartInfo.param.series)]] = yItem
            })
          })
          // 重新设置y轴的数据
          let yAxis = []
          data.data.map((dataItem, dataIndex) => {
            yAxis.push({
              name: dataItem[this.splitField(chartInfo.param.series)],
              field: dataItem[this.splitField(chartInfo.param.series)]
            })
          })
          chartInfo.param.y = [ ...yAxis ]
        }
      }
      return seriesDataList
    },
    translateChartFormat (chartInfo, data) {
      let columns = []
      columns.push(this.splitField(chartInfo.param.x.field))
      chartInfo.param.y.map(item => {
        columns.push(chartInfo.extend.isSeries ? item.field : this.splitField(item.field))
      })
      let colors = chartInfo.extend.colorList ? chartInfo.extend.colorList : seriesColor
      let style = chartInfo.extend.style ? chartInfo.extend.style : {
        height: 262,
        width: 402
      }
      let chartObj = {
        title: chartInfo.name,
        chartId: `${chartInfo.id}`,
        style: style,
        type: chartInfo.type.toUpperCase(),
        chartData: {
          colors: colors.splice(0, columns.length - 1),
          rows: data,
          columns: columns,
          xName: chartInfo.param.x.name,
          formatMap: {},
          labelMap: {}
        }
      }
      if (chartInfo.extend.isSeries) {
        chartObj.chartStyle = {
          grid: {
            left: '4%',
            bottom: chartInfo.param.x.name ? '12%' : '6%',
            top: '18%',
            right: '6%',
            containLabel: true
          },
          legend: {
            type: 'scroll',
            width: '70%',
            top: '4%',
            data: columns.filter((item, index) => index > 0)
          }
        }
      } else if (chartInfo.param.x.name) {
        chartObj.chartStyle = {
          grid: {
            left: '4%',
            bottom: '12%',
            top: '10%',
            right: '6%',
            containLabel: true
          }
        }
      }
      if (columns[0].toLowerCase().indexOf('time') > -1) {
        chartObj.chartData.formatMap[columns[0]] = 'TIME'
      }
      chartInfo.param.y.map((item, index) => {
        if (item.name) {
          chartObj.chartData.labelMap[chartInfo.extend.isSeries ? item.field : this.splitField(item.field)] = item.name
        }
      })
      return chartObj
    },
    splitField (str) {
      if (str.indexOf('.') > -1) {
        return str.split('.')[str.split('.').length - 1]
      }
      return str
    },
    e_save () {
      this.$refs['dashboardform'].validate((valid) => {
        if (valid) {
          let eventName = this.$route.query.id ? 'updateBoard' : 'saveBoard'
          let saveObj = {
            name: this.formModel.name,
            viewList: []
          }
          this.chartDataList.map(item => {
            saveObj.viewList.push({
              viewId: item.chartId,
              style: {
                width: item.style.width,
                height: item.style.height
              }
            })
          })
          if (this.$route.query.id) saveObj.id = this.$route.query.id
          dashBoardBiz[eventName](saveObj).then(data => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.$router.push({ name: 'dashBoard' })
          })
        } else {
          return false
        }
      })
    },
    e_showList () {
      this.showList = !this.showList
    }
  },
  mounted () {
    this.init()
  }
}
</script>